const deployment = {
    APP_NAME: 'Aqua Mail',
    PLATFORM_API_URL: 'https://api.aqua-mail.com',
    INTERNAL_API_URL: "http://127.0.0.1:7042",
    PLATFORM_API_VERSION: 'v1',
    STRIPE_API_KEY: 'pk_live_51R1pixIHO7elQfbPiXIwQU4hnwChMVB5kIuoYnEvLpf5gpB4JiPDddVJLkzwz4NPtfL4bnexMeX5Ithig7vxzW4D00V5IG1NIL',
    APP_DOMAIN: 'aqua-mail.com',
    SUPPORT_CHAT_API: 'https://api.aqua-mail.com/v1/chat',
    CMS_STATIC_URL: 'https://api.aqua-mail.com/cms/static',
    GTM_ID: "GTM-K5TT68R8",
    FACEBOOK_PIXEL: "",
    FACEBOOK_OPTIONS: false,
    TRACKING_GDPR: false,
    GOOGLE_ANALYTICS_ID: "",
    ENABLE_DEBUG_OVERLAY: false,
    ENCRYPTION_ENABLED: true,
    INFLIGHT_ENCRYPTION_KEY: "fqPS9fA3f2I8MVjyATH1snqFrKXwFwsSMxW7ktcVWdk="
};

export default deployment;
